import { Box, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { RiskIcon } from "Components/Shared/Icons";
import { PaymentErrorCode, TransactionStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getPaymentFailureMessageKey } from "Utils/PaymentErrorUtils";

const ComponentResources = Resources.Transactions.ErrorPayment;

// The user did nothing wrong here — the payment just did not happen. "An error occurred" would be misleading.
const NOT_COMPLETED_REASONS = [
  PaymentErrorCode.Expired,
  PaymentErrorCode.UserCancelled,
];

type Props = {
  failureReason?: PaymentErrorCode;
  /** The transaction was cancelled (by the payer or by the expiry sweep) rather than failed. */
  isCancelled?: boolean;
};

export const FailedTransactionInfo = ({
  failureReason,
  isCancelled = false,
}: Props) => {
  const { t } = useResource();
  const failureMessageKey = getPaymentFailureMessageKey(failureReason);
  const isNotCompleted =
    isCancelled ||
    (!!failureReason && NOT_COMPLETED_REASONS.includes(failureReason));
  const fallbackDescriptionKey = isCancelled
    ? Resources.Transactions.TransactionStatus[TransactionStatus.Cancelled]
    : ComponentResources.Description;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      color={Colors.Red}
    >
      <RiskIcon />
      <Typography variant="h5" my={1}>
        {t(
          isNotCompleted
            ? ComponentResources.TitleNotCompleted
            : ComponentResources.Title,
        )}
      </Typography>
      <Typography lineHeight="28px" textAlign="center">
        {t(failureMessageKey ?? fallbackDescriptionKey)}
      </Typography>
    </Box>
  );
};
